import React, { useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import {Snackbar, SnackbarContent} from "@mui/material";
import Agent from "../../../Network/Agent";
import {handleSnackbarClose, objectsEqual} from "../../../Components/Utils/utilities";
import ToolBar from "../../../Components/Elements/ToolBar";
import {getGeneratedRoute, RouteEnumFinal} from "../../../Config/RouteEnum";
import ButtonPrimary from "../../../Components/Elements/ButtonPrimary";
import {useNavigate} from "react-router-dom";

const CategoryListSorting = React.memo(() => {
    const storeUsername = window.location.host.split(".")[0];

    const [categories, setCategories] = useState([]);
    const [submitBtnDisplay , setSubmitBtnDisplay] = useState("d-none")
    const [submitBtnIsLoading , setSubmitBtnIsLoading] = useState(false)
    const [snackbarOpen , setSnackbarOpen] = useState(false)
    const [snackbarMessage , setSnackbarMessage] = useState("")

    const navigate = useNavigate()

    const vertical = "bottom"
    const horizontal = "center"

    const getCategoryList = () => {
        Agent.Category.getListPanel(storeUsername)
            .then(response => {
                let categories = response.data.result.categories;
                console.log(categories)
                setCategories(categories);
            })
            .catch(error => {
                console.log(error.response);
            });
    };

    useEffect(() => {
        getCategoryList();
    }, []);

    const handleOnDragEnd = result => {
        if (!result.destination) return;
        const newArray = Array.from(categories);
        const [draggedItem] = newArray.splice(result.source.index, 1);
        newArray.splice(result.destination.index, 0, draggedItem);
        if (!objectsEqual(newArray , categories)) {
            setSubmitBtnDisplay("d-block")
            setCategories(newArray);
        }
    };

    const handleSubmitBTN = () => {
        setSubmitBtnIsLoading(true)
        let finalList = [];
        for (let i = 0; i < categories.length; i++) {
            finalList.push({
                sort : i,
                code : categories[i].code,
            });
        }

        Agent.Category.updateSorting(finalList)
            .then(response => {
                setSubmitBtnIsLoading(false)
                setSubmitBtnDisplay("d-none")
                setSnackbarMessage(response.data.message)
                setSnackbarOpen(true)
            })
            .catch(error => {
                setSubmitBtnIsLoading(false)
                console.log(error.response);
            });
    }

    return (
        <div className="pb-64">
            <ToolBar
                customClasses={'box-shadow'}
                title={'دسته بندی ها'}
                navigate={() => navigate(-1)}>
                <div className={submitBtnDisplay}
                     onClick={handleSubmitBTN}>
                    <ButtonPrimary
                        mode="light-mode"
                        spinnerClasses="cl-blue"
                        isLoading={submitBtnIsLoading}>
                        <div className="mobile-h4 desktop-h4 cl-blue">
                            تایید
                        </div>
                    </ButtonPrimary>
                </div>
            </ToolBar>
            <div className="container mt-20">
                <div className="row">
                    <div className="col-12">
                        <div className="mobile-body-1-regular cl-subtitle text-center">
                            روی هر آیتم نگه دارید و سپس آن را جابجا کنید.
                        </div>
                    </div>
                </div>
            </div>
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <div className="container mt-3">
                    <Droppable droppableId="categories">
                        {provided => (
                            <div className="row" ref={provided.innerRef} {...provided.droppableProps}>
                                {categories.map(({ code, title, status }, index) => (
                                    <Draggable key={code} draggableId={code} index={index}>
                                        {provided => (
                                            <div
                                                className="col-12"
                                                ref={provided.innerRef}
                                                {...provided.dragHandleProps}
                                                {...provided.draggableProps}
                                            >
                                                <div className="d-flex justify-content-between align-items-center p-20 border bg-white">
                                                    <div className="mobile-h5 cl-black">{title}</div>
                                                    <div className="d-flex align-items-center">
                                                        {status === 'active' ? (
                                                            <div className="mobile-body-1-strong cl-grass">فعال</div>
                                                        ) : (
                                                            <div className="mobile-body-1-strong cl-tomato">غیر فعال</div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </div>
            </DragDropContext>
            <Snackbar open={snackbarOpen}
                      autoHideDuration={4000}
                      onClose={() => {
                          handleSnackbarClose()
                          setSnackbarOpen(false);
                      }}
                      anchorOrigin={{vertical , horizontal}}
                      key={vertical + horizontal}>
                <SnackbarContent
                    className="dir-rtl font-family-dana"
                    message={snackbarMessage} />
            </Snackbar>
        </div>
    );
});

export default CategoryListSorting;
